import { call, put, takeLatest } from 'redux-saga/effects';

import { FaceIdService } from '../../../../entities/FaceId/services';
import { syncFaceIdError, syncFaceIdSuccess } from './actions';
import { SYNC_FACE_ID_REQUEST } from './constants';

interface SyncFaceIdAction {
  type: typeof SYNC_FACE_ID_REQUEST;
  payload: {
    branchId: string;
  };
}

function* SyncFaceId(action: SyncFaceIdAction) {
  try {
    const { branchId } = action.payload;
    yield call(FaceIdService.syncFaceId, branchId);

    yield put(syncFaceIdSuccess());
  } catch (error: any) {
    yield put(syncFaceIdError(error));
  }
}

export function* SyncFaceIdWatcher() {
  yield takeLatest(SYNC_FACE_ID_REQUEST, SyncFaceId);
}
